import { useTranslation } from 'react-i18next'

import {
  ArrowLeftIcon,
  CloseIcon,
  Box as DarkBox,
  IconButton,
} from '@hivewatch/dark'

import { darkCheckPointsPanelStyles } from './DarkCheckPointsPanel.styles'

interface DarkEditCheckPointHeaderIProps {
  colorScheme: 'dark' | 'light'
  isEditMode: boolean
  onClose: () => void
}

/**
 * Header slot for the Checkpoint detail rail. Outside Edit Mode the control is
 * a back arrow — the view is read-only and the action is "go back"; inside it,
 * a bare close ✕, the same affordance the incident drawer uses to dismiss a
 * form.
 */
export const DarkEditCheckPointHeader = ({
  colorScheme,
  isEditMode,
  onClose,
}: DarkEditCheckPointHeaderIProps) => {
  const { t } = useTranslation()
  const s = darkCheckPointsPanelStyles(colorScheme)

  return (
    <DarkBox {...s.editHeaderRow}>
      <DarkBox alignItems='center' display='flex' gap='8px'>
        {!isEditMode && (
          <IconButton
            aria-label={t('floors:checkpoint_close_edit_aria')}
            colorScheme={colorScheme}
            dimension={36}
            icon={
              <ArrowLeftIcon colorScheme={colorScheme} height={20} width={20} />
            }
            onClick={onClose}
          />
        )}
        <DarkBox as='h2' {...s.headerTitle}>
          {isEditMode
            ? t('floors:checkpoint_edit_header_title')
            : t('floors:checkpoint_view_header_title')}
        </DarkBox>
      </DarkBox>
      {isEditMode && (
        <IconButton
          aria-label={t('floors:checkpoint_close_edit_aria')}
          colorScheme={colorScheme}
          data-testid='DarkEditCheckPoint:close'
          dimension={36}
          icon={<CloseIcon size={11} />}
          onClick={onClose}
        />
      )}
    </DarkBox>
  )
}
